import React from "react";

import { Avatar, List, Select, message } from "antd";

import { _getEnterpriseData, _getTermContractLogBatch, _getTermContractLogs } from "../../services";
import { ACTIVITY_TYPES, entrySentence, loggedEnterpriseIds, rowSentence } from "./activity-text";
import { errorMessage, toDateTime } from "./helpers";

const MUTED = "rgba(0,0,0,0.45)";

/** One grouped upload / bulk entry: its first items, and "Show all N" fetches the rest. */
class BatchItems extends React.Component {

    state = { items: null, loading: false };

    showAll = async () => {
        this.setState({ loading: true });
        try {
            const { data } = await _getTermContractLogBatch({ id: this.props.contractId, batchId: this.props.entry.batchId });
            this.setState({ items: data.items, loading: false });
        } catch (e) {
            message.error(errorMessage({ error: e }));
            this.setState({ loading: false });
        }
    };

    render() {
        const { entry } = this.props;
        const items = this.state.items || entry.items || [];
        return (
            <div style={{ fontSize: 13, background: "#fafafa", border: "1px solid #f0f0f0", borderRadius: 4, padding: "8px 12px", marginTop: 6 }}>
                {items.map(row => <div key={row._id}>{rowSentence({ row })}</div>)}
                {!this.state.items && entry.count > items.length && (
                    <a onClick={this.showAll}>{this.state.loading ? "Loading…" : `… show all ${entry.count}`}</a>
                )}
            </div>
        );
    }
}

/** The activity tab: an upload or bulk action is one expandable entry, in plain sentences. */
class TermContractActivity extends React.Component {

    state = { logs: [], total: 0, page: 1, pageSize: 50, type: "", userId: "", expanded: {}, enterpriseNames: {}, loading: false };

    componentDidMount() {
        this.load({ page: 1 });
    }

    load = async ({
        page,
    }) => {
        const { type, userId } = this.state;
        this.setState({ loading: true, page });
        try {
            const { data } = await _getTermContractLogs({ id: this.props.contractId, page, type, userId });
            this.setState({ logs: data.logs, total: data.total, pageSize: data.pageSize });
            this.loadEnterpriseNames({ rows: data.logs });
        } catch (e) {
            message.error(errorMessage({ error: e }));
        } finally {
            this.setState({ loading: false });
        }
    };

    /* ponytail: one request per enterprise id; an enterprise change is rare. */
    loadEnterpriseNames = ({
        rows,
    }) => loggedEnterpriseIds({ rows }).filter(id => !this.state.enterpriseNames[id]).forEach(id => _getEnterpriseData(id)
        .then(res => res.data.enterprise && this.setState(state => ({
            enterpriseNames: { ...state.enterpriseNames, [id]: res.data.enterprise.companyName }
        })))
        .catch(e => console.error("Failed to load enterprise", id, e)));

    toggle = ({
        key,
    }) => this.setState(state => ({ expanded: { ...state.expanded, [key]: !state.expanded[key] } }));

    renderEntry = entry => {
        const { adminName, contractId } = this.props;
        const key = entry.batchId || entry._id;
        const who = adminName({ userId: entry.createdByUserId });
        const open = !!this.state.expanded[key];
        return (
            <List.Item key={key}>
                <List.Item.Meta
                    avatar={<Avatar style={{ background: "#0b5cad" }}>{`${who}`.charAt(0).toUpperCase()}</Avatar>}
                    title={<span><b>{who}</b> {entrySentence({ entry, enterpriseNames: this.state.enterpriseNames })}</span>}
                    description={(
                        <div>
                            <span style={{ color: MUTED }}>{toDateTime({ date: entry.createdAt })}</span>
                            {entry.batchId && (
                                <a style={{ marginLeft: 12 }} onClick={() => this.toggle({ key })}>
                                    {open ? "Hide details" : `Show ${entry.count} change${entry.count === 1 ? "" : "s"}`}
                                </a>
                            )}
                            {open && <BatchItems contractId={contractId} entry={entry} />}
                        </div>
                    )}
                />
            </List.Item>
        );
    };

    render() {
        const { admins } = this.props;
        const { logs, total, page, pageSize, type, userId, loading } = this.state;
        return (
            <div>
                <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                    <Select aria-label="Filter by type" value={type} style={{ width: 260 }}
                        onChange={value => this.setState({ type: value, expanded: {} }, () => this.load({ page: 1 }))}>
                        {ACTIVITY_TYPES.map(t => <Select.Option key={t.value} value={t.value}>{t.label}</Select.Option>)}
                    </Select>
                    <Select aria-label="Filter by person" showSearch optionFilterProp="children" value={userId} style={{ width: 260 }}
                        onChange={value => this.setState({ userId: value, expanded: {} }, () => this.load({ page: 1 }))}>
                        <Select.Option value="">Anyone</Select.Option>
                        {Object.keys(admins).map(id => <Select.Option key={id} value={id}>{admins[id]}</Select.Option>)}
                    </Select>
                </div>
                <List
                    loading={loading}
                    dataSource={logs}
                    renderItem={this.renderEntry}
                    pagination={total > pageSize ? { current: page, pageSize, total, onChange: p => this.load({ page: p }) } : false}
                />
            </div>
        );
    }
}

export default TermContractActivity;



// WEBPACK FOOTER //
// ./src/components/term-contract/activity.js